export interface INavigationState {
}

export const initialNavigationState: INavigationState = {
};
